import * as React from "react";
import * as ReactDOM from "react-dom";
import { request } from "../../../services/cpln";
import { Affix, Alert } from "antd";
import { useAppSelector } from "../../../store/hooks";
import { selectOrg } from "../../../store/contextSlice";

export const OrgInactiveAlert: React.FC = () => {
  const org = useAppSelector(selectOrg);
  const [isOrgInactive, setIsOrgInactive] = React.useState(false);

  React.useEffect(() => {
    fetchOrg();
  }, [org]);

  async function fetchOrg() {
    try {
      const { data: orgItemRes } = await request({ url: `/org/${org}` });
      setIsOrgInactive(orgItemRes.status.active === false);
    } catch (e) {
      setIsOrgInactive(false);
    }
  }

  if (isOrgInactive) {
    return ReactDOM.createPortal(
      <Affix offsetBottom={20}>
        <Alert
          type="warning"
          message={`This organization is inactive. Please contact your organization administrator to reactivate this
        organization.`}
        />
      </Affix>,
      document.getElementById("affix-root")!,
    );
  }

  return null;
};
